import { ComponentType } from '@angular/cdk/portal';
import { Injectable } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { DialogPosition, MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';


import { BottomSheetComponent, IBottomSheetData, ModalComponent } from '@app/eds';
import { IDialogPosition } from '@app/eds/models/comment.model';

@Injectable({
  providedIn: 'root'
})
export class ModalService {
  // ActivatedRoute will store the value for current route;
  activatedRoute = new BehaviorSubject<ActivatedRoute | null>(null);

  constructor(
    private matDialog: MatDialog,
    private router: Router,
    private bottomSheet: MatBottomSheet
  ) { }

  /**
   * Changes the actiavted route.
   *
   * @param {ActivatedRoute} value
   */
  switchActivatedRoute = (value: ActivatedRoute) => this.activatedRoute.next(value);

  /**
   * This opens modal from right.
   *
   * @param {Component} componentToDisplay
   * @param {string} redirectRoute
   */
  openModalFromRight = (
    componentToDisplay: ComponentType<any>,
    redirectRoute: string = ''
  ) => {
    const dialogPosition: DialogPosition = {
      right: '0'
    };
    const dialogRef = this.matDialog.open(componentToDisplay, {
      panelClass: 'custom-dialog-right',
      width: '75%', //Width of the Modal
      height: '100%', // Height of the Modal
      position: dialogPosition,
      autoFocus: false
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.router.navigate([redirectRoute]);
    });
  };

  /**
   * This opens modal from center.
   *
   * @param data
   * @param callBack
   * @param {string} customClass
   * @param {boolean} disableClose
   * @param {IDialogPosition} dialogPosition
   * @param {string[]} backdropClass
   */
  openModalFromCenter = (
    data: any,
    callBack?: any,
    customClass?: string,
    disableClose: boolean = true,
    dialogPosition?: IDialogPosition,
    backdropClass?: string[]
  ) => {
    const dialogRef = this.matDialog.open(ModalComponent, {
      id: data?.id,
      panelClass: ['custom-dialog-center', customClass as string],
      width: data?.width,
      height: data?.height,
      autoFocus: true,
      data: data,
      disableClose: disableClose,
      position: dialogPosition,
      backdropClass: backdropClass
    });

    dialogRef.afterClosed().subscribe(() => {
      callBack();
    });
  };

  /**
   * Will open bottom sheet.
   *
   * @param {IBottomSheetData} data
   * @param {Function | null | undefined} callBack
   */
  openBottomSheet = <T>(
    data: IBottomSheetData<T>,
    callBack: Function | null | undefined
  ) => {
    const dialogRef = this.bottomSheet.open(BottomSheetComponent, {
      data: data,
      autoFocus: false
    });

    dialogRef.afterDismissed().subscribe(() => {
      callBack && callBack();
    });
  };

  /**
   * Closes bottom sheet.
   */
  closeBottomSheet = () => this.bottomSheet.dismiss();

  /**
   * Closes the modal.
   */
  closeModal = () => this.matDialog.closeAll();

  /**
   * This method will call to close a particular modal.
   *
   * @param {string} dialogId is the modal ID
   */
  closeModalById = (dialogId: string) => {
    this.matDialog.getDialogById(dialogId)?.close();
  };
}
